(() => {
  const setupGallery = (gallery) => {
    if (gallery.dataset.hbReady === 'true') return;
    gallery.dataset.hbReady = 'true';

    const track = gallery.querySelector('[data-hb-track]');
    const slides = [...gallery.querySelectorAll('[data-hb-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-hb-thumbnail]')];
    const previous = gallery.querySelector('[data-hb-prev]');
    const next = gallery.querySelector('[data-hb-next]');
    const status = gallery.querySelector('[data-hb-status]');
    let activeIndex = 0;

    const render = (nextIndex) => {
      activeIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
      if (track) track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
      slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== activeIndex)));
      thumbnails.forEach((thumbnail, index) => {
        const selected = index === activeIndex;
        thumbnail.setAttribute('aria-selected', String(selected));
        thumbnail.classList.toggle('is-active', selected);
      });
      previous?.toggleAttribute('disabled', activeIndex === 0);
      next?.toggleAttribute('disabled', activeIndex === slides.length - 1);
      if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => render(index)));
    previous?.addEventListener('click', () => render(activeIndex - 1));
    next?.addEventListener('click', () => render(activeIndex + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') render(activeIndex - 1);
      if (event.key === 'ArrowRight') render(activeIndex + 1);
    });
    render(0);
  };

  const setupFaq = (root) => {
    root.querySelectorAll('[data-hb-faq]').forEach((button) => {
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const panel = button.nextElementSibling?.matches('[data-hb-faq-panel]') ? button.nextElementSibling : null;
        button.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  };

  const setup = (scope = document) => {
    scope.querySelectorAll('[data-hb-offer]').forEach((root) => {
      if (root.dataset.hbInteractionsReady === 'true') return;
      root.dataset.hbInteractionsReady = 'true';
      root.querySelectorAll('[data-hb-gallery]').forEach(setupGallery);
      setupFaq(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
